import PropTypes from 'prop-types';
import React from 'react';

import Image from '../../components/ContentfulImage';
import Placeholder from '../../components/Placeholder';
import SectionLabel from './SectionLabel';
import Slider from '../../components/Slider/Slider';

import {
  VisionSection,
  VisionTitle,
  VisionDescription,
  Gallery,
  Slide,
  ImageContainer,
  Artist,
  ArtistQuote,
  ArtistImage,
  ArtistDescription,
  ArtistName,
  ArtistTitle,
} from './OurVisionSection.style';

const Vision = ({ label, title, description, bios }) => (
  <VisionSection id="our-vision-section">
    <SectionLabel>{label || <Placeholder h="20px" w="100px" />}</SectionLabel>
    <VisionTitle>{title || <Placeholder h="48px" w="300px" />}</VisionTitle>
    <VisionDescription>{description || <Placeholder h="75px" w="100%" />}</VisionDescription>

    <Gallery>
      {bios ? (
        <Slider
          auto={5000}
          dots
          dotsColor="#333"
          dotsStyle={{ bottom: -20 }}
          keys={bios.map(bio => bio.entryId || bio.key)}
          options={{
            draggable: true,
            duration: 800,
            easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
            loop: true,
            perPage: 1,
          }}
        >
          {bios.map(bio => (
            <Slide key={bio.entryId || bio.key}>
              <ImageContainer>
                {bio.workImage ? (
                  <Image src={bio.workImage} options={{ size: 1060, w: '100%' }} />
                ) : (
                  <Placeholder w="100%" pb="calc(5000% / 53)" />
                )}
              </ImageContainer>

              <Artist key={bio.title || bio.key}>
                <ArtistImage>
                  {bio.person.image ? (
                    <Image src={bio.person.image} options={{ size: [170, 260, 310], w: '100%' }} />
                  ) : (
                    <Placeholder pb="calc(200% / 3)" w="100%" />
                  )}
                </ArtistImage>
                <ArtistQuote>{bio.title || <Placeholder h="40px" w="100%" />}</ArtistQuote>
                <ArtistDescription>{bio.description || <Placeholder h="90px" w="100%" />}</ArtistDescription>
                <ArtistName>{bio.person.name || <Placeholder h="23px" w="100px" />}</ArtistName>
                <ArtistTitle>{bio.person.title || <Placeholder h="23px" w="150px" />}</ArtistTitle>
              </Artist>
            </Slide>
          ))}
        </Slider>
      ) : (
        <Placeholder w="100%" pb="100%" />
      )}
    </Gallery>
  </VisionSection>
);

Vision.defaultProps = {
  label: undefined,
  title: undefined,
  description: undefined,
  bios: undefined,
};

Vision.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  bios: PropTypes.arrayOf(PropTypes.shape()),
};

export default Vision;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/OurVisionSection.js